import { RaModule } from 'resources/RaModule';
import { ResourceName, ResourceIntent } from 'shared/enums';

export const UserPlansModule = RaModule.fromResourceProps({
  name: ResourceName.USERS_PLANS,
  intent: ResourceIntent.REGISTRATION
});
